export default "__VITE_ASSET__CSl2T3KZ__"